import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AssessmentHeader from "./AssessmentHeader"; // Moved outside the main container
import AssessmentOptions from "./AssessmentOptions";
import AssessmentQuestions from "../AssessmentSkillTest/AssessmentQuestions";
import AssessmentTimer from "./AssessmentTimer";
import AssessmentButton from "./AssessmentContinueButton";
import Loader from "../../../../shared_components/Loader";
import AlreadyCompletedQuiz from "../../../QuizStudio/component/common/AlreadyCompletedQuiz";

import { submitQuizTest } from "../../../QuizStudio/actions";
import { fetchQuizTestDetails } from "../../actions";
import "./../../../../assets/scss/Assesment/Assessment.scss";

const Assessment = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { currentQuizTest, quizTestSubmittingLoading } = useSelector(
    (state) => state?.quizTest
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [progress, setProgress] = useState(0);
  const [isloading, setIsLoading] = useState(true);
  const [hasCompleted, setHasCompleted] = useState(false);
  const [showAlreadyCompleted, setShowAlreadyCompleted] = useState(false);
   
  const quizTest = currentQuizTest?.quizTest;
  const quizTestsQuestions = currentQuizTest?.quizQuestions;

  useEffect(() => {
    // dispatch(fetchQuizTestDetails(id)).then((res) => {
    //   setHasCompleted(res?.data?.hasCompleted);
    //   setIsLoading(false);
    // });
    const loadQuiz = async () => {
        try{
          const res = await dispatch(fetchQuizTestDetails(id));
          const completed = res?.data?.hasCompleted;
          setHasCompleted(completed);
    
          if(completed==false){
            setShowAlreadyCompleted(false);
            setIsLoading(false);
            return;
          }
    
          const quiz = res?.data?.quizTest;
    
          const canStart=
            quiz?.access === "public" && 
            Boolean(quiz?.quizId) &&
            Array.isArray(quiz?.quizQuestions);
    
            setShowAlreadyCompleted(!canStart);
        } catch (error) {
          setShowAlreadyCompleted(true);
        } finally {
          setIsLoading(false);
        } 
      };
    
        loadQuiz();

    const savedAnswers = localStorage.getItem(`quiz-${id}-answers`);
    setAnswers(savedAnswers ? JSON.parse(savedAnswers) : []);

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      return false;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [dispatch, id]);

  const handlePageChange = (action) => {
    if (Array.isArray(quizTestsQuestions) && action === "Next") {
      setCurrentPage((prev) =>
        Math.min(prev + 1, quizTestsQuestions?.length - 1)
      );
    }
  };

  const handleClick = () => {
    const totalQuestions = quizTestsQuestions?.length;
    const selectedCount = answers?.length;
    setProgress(Math.round((selectedCount / totalQuestions) * 100));
    handlePageChange("Next");
  };

  const handleOptionChange = (questionId, selectedAnswer) => {
    const updatedAnswers = [...answers];
    const index = updatedAnswers.findIndex(
      (answer) => answer?.questionId === questionId
    );
    if (index > -1) {
      updatedAnswers[index].selectedAnswer = selectedAnswer;
    } else {
      updatedAnswers.push({ questionId, selectedAnswer });
    }
    localStorage.setItem(`quiz-${id}-answers`, JSON.stringify(updatedAnswers));
    setAnswers(updatedAnswers);
  };

  const handleSubmit = async () => {
    try {
      const response = { quizTestId: id, answers };
      await dispatch(submitQuizTest(response)).then((res) => {
        if (res) {
          const access_token = localStorage.getItem("access_token");
          const userDetails = localStorage.getItem("userDetails");
          localStorage.clear();
          localStorage.setItem("access_token", access_token);
          localStorage.setItem("userDetails", userDetails);
          navigate(`/assessment/test/${id}/report`);
        }
      });
    } catch (error) {
      console.error("Error submitting quizTest:", error);
      alert("There was an error submitting your quiz.");
    }
  };

  return (
    <div className="bg-default">
      {quizTestSubmittingLoading ? (
        <Loader />
      ) : (
        <div>
          <AssessmentHeader progress={progress} />
          <div className="assessment-container rounded bg-default">
            {isloading ? (
              <Loader />
            ) : showAlreadyCompleted ? (
              <div>
                <AlreadyCompletedQuiz testType={"assessment"} />
              </div>
            ) : (
              <div>
                <div>
                  <div className="rounded-lg shadow-sm p-md-4 bg-default">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center py-2 px-4 border-bottom">
                      <h2 className="text-gradient-primary fw-bold py-2 text-capitalize py-md-0 fs-1 mb-2 mb-md-0">
                        {quizTest && quizTest?.quizTechnology + " Assessment"}
                      </h2>
                      {quizTestsQuestions && (
                        <AssessmentTimer
                          timeInMinutes={quizTest?.duration || 1}
                          handleSubmit={handleSubmit}
                        />
                      )}
                    </div>
                    <div className="row g-4 mt-3 mx-0 card-custom-default text-white">
                      <div className="col-lg-6 p-3 rounded-start shadow-sm text-white">
                        {quizTestsQuestions && (
                          <AssessmentQuestions
                            answers={answers}
                            currentPage={currentPage}
                            quizTestsQuestions={quizTestsQuestions}
                            handleOptionChange={handleOptionChange}
                          />
                        )}
                      </div>
                      <div className="col-lg-6 p-3 rounded-end shadow-sm">
                        <div className="assessment-options">
                          {quizTestsQuestions && (
                            <AssessmentOptions
                              answers={answers}
                              currentPage={currentPage}
                              quizTestsQuestions={quizTestsQuestions}
                              handleOptionChange={handleOptionChange}
                            />
                          )}
                        </div>
                        <div className="mt-3">
                          <AssessmentButton
                            currentPage={currentPage}
                            quizTestsQuestions={quizTestsQuestions}
                            handleClick={handleClick}
                            handleSubmit={handleSubmit}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-4 p-3 bg-default border rounded">
                      <h5 className="text-white">Instructions:</h5>
                      <ul className="text-white">
                        <li>Each question has only one correct answer.</li>
                        <li>
                          You can revisit and change your answer before
                          submission.
                        </li>
                        <li>
                          Use the "Next" button to move to the next question.
                        </li>
                        <li>
                          Make sure to submit your test before time runs out.
                        </li>
                      </ul>
                    </div>
                    <div className="text-end mt-4 border-top pt-3">
                      <p className="m-0 text-light">
                        Report an issue{" "}
                        <a href="#" className="text-primary">
                          here
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Assessment;
